import type { FaireProductEntity } from "../../entity_types/product";

export const p_r8p3r7q45s: FaireProductEntity = {
  token: "p_r8p3r7q45s",
  type: "product",
  name: "STACEY",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/35d6c7aeb2b09ce28c8c5b7a7251b9db02da39c63007c004eba9df878d9b3856.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/537b5f6fbc56e4accbba86e30d5af6ba84119ab733f82b1664f7f115139340c6.png",
    "https://cdn.faire.com/fastly/a0be9449d856297f451a06786ce3f500fc493912697ec0dd57900a8b58346333.png",
    "https://cdn.faire.com/fastly/2bb151b2a8c0aeea21560d725fc065957f517e90fafaf6e94a720fd0ebc96a65.png"
  ],
  priceDollars: 10.05,
  description: "Rich, Smokey, Resolute\n\nA rich, smokey coffee built for fans of medium-dark roasts. Named for Atlanta-born political activist Stacey Abrams.\n\nTasting Notes: Smokey hazelnut, caramel\nFeatured Coffee: Colombia Nariño (rotating)\nRegion: Nariño, Colombia\nProducer: Buesaco Community\nVarieties: Caturra, Castillo, Colombia\nAltitude: 2,000 masl\nProcess: Washed\nRoast Level: Medium-Dark\nRecommended Brew: Drip, French press, or espresso with milk\n\nStacey is named for Stacey Abrams, the Atlanta-born political activist, voting rights champion, and author whose work has shaped how the country thinks about democracy and the South. The coffee is unapologetic in its character: deep, smokey, sweet with hazelnut and caramel, the kind of cup that lingers.\n\nWhole bean or ground, roasted to order in Atlanta. Available in 310 g, 2 lb, and 5 lb.\n",
  tags: [],
  msrpDollars: 16.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:09.383Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
